import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme, keyframes } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate, { translate } from './Translate';
import Badge from './Badge';
import Icon from './Icon';

const bounce = keyframes`
    from,
    20%,
    53%,
    80%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: translate3d(0, 0, 0);
    }
  
    40%,
    43% {
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      transform: translate3d(0, -0.5em, 0);
    }
  
    70% {
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      transform: translate3d(0, -0.25em, 0);
    }
  
    90% {
      transform: translate3d(0, -0.05em, 0);
    }
`;

const Wrapper = styled<any, any>('div')`
    ${propStyles};
`;

Wrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
};

const DownloadButtonIcon = styled<any, any>(Icon)``;

DownloadButtonIcon.defaultProps = {
    marginX: 'sm',
    height: '1.6em',
    width: '1.6em',
};

const Button = styled<any, any>('button')`
    ${propStyles};
    &:hover {
        ${DownloadButtonIcon} {
            animation-name: ${bounce};
            animation-duration: 1s;
            animation-fill-mode: both;
            transform-origin: center bottom;
        }
    }
`;

Button.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    paddingX: '0',
    paddingY: '0',
    fontSize: 'inherit',
    fontFamily: 'body',
    fontWeight: 'regular',
    textAlign: 'left',
    color: 'inherit',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    outline: 'none',
    hover: {
        color: 'primary',
    },
};

export const DownloadControls: React.SFC<any> = ({
    theme,
    translations,
    label,
    showCount = true,
    showDownload = true,
    count = 0,
    onClick,
    disabled,
    downloadButtonFileName = 'DownloadIcon',
    isMobile = false,
    ...props
}) => {
    // Set up the object assign to avoid breaking existing style selectors
    const downloadControlsTheme = isMobile
        ? Object.assign(
              {},
              ...theme.DownloadControls,
              ...theme.DownloadControlsMobile
          )
        : theme.DownloadControls;
    const downloadButtonTheme = isMobile
        ? Object.assign(
              {},
              ...theme.DownloadButton,
              ...theme.DownloadButtonMobile
          )
        : theme.DownloadButton;
    const downloadButtonIconTheme = isMobile
        ? Object.assign(
              {},
              ...theme.DownloadButtonIcon,
              ...theme.DownloadButtonIconMobile
          )
        : theme.DownloadButtonIcon;
    const downloadCountTheme = isMobile
        ? Object.assign(
              {},
              ...theme.DownloadCount,
              ...theme.DownloadCountMobile
          )
        : theme.DownloadCount;
    return (
        <Wrapper {...props} {...downloadControlsTheme}>
            {showDownload && (
                <Button
                    title={translate(translations, 'Download')}
                    onClick={onClick}
                    disabled={disabled}
                    {...downloadButtonTheme}
                >
                    {label && <Translate>{label}</Translate>}
                    <DownloadButtonIcon
                        fileName={downloadButtonFileName}
                        {...downloadButtonIconTheme}
                    />
                </Button>
            )}
            {showCount && (
                <Badge bgColor="primary" {...downloadCountTheme}>
                    {count}
                </Badge>
            )}
        </Wrapper>
    );
};

export default inject('translations')(
    withTheme(observer(DownloadControls))
) as any;



// WEBPACK FOOTER //
// ./src/Components/DownloadControls.tsx